<template>
<div class="chapter">
<div class="inner_page">
<h1><b>Contents</b></h1>
<p class="toc1"><a href="#/Text/ch1#tahir22" id="tahir022">ONE</a></p>
<p class="toc1"><a href="#/Text/ch2#tahir23" id="tahir023">TWO</a></p>
<p class="toc1"><a href="#/Text/ch3#tahir24" id="tahir024">THREE</a></p>
<p class="toc1"><span href="#/Text/ch4#tahir25" id="tahir025" title="Link target outside of Sample">FOUR</span></p>
<p class="toc1"><span href="#/Text/ch5#tahir26" id="tahir026" title="Link target outside of Sample">FIVE</span></p>
<p class="toc1"><span href="#/Text/ch6#tahir27" id="tahir027" title="Link target outside of Sample">SIX</span></p>
<p class="toc1"><span href="#/Text/ch7#tahir28" id="tahir028" title="Link target outside of Sample">SEVEN</span></p>
<p class="toc1"><span href="#/Text/ch8#tahir29" id="tahir029" title="Link target outside of Sample">EIGHT</span></p>
<p class="toc1"><span href="#/Text/ch9#tahir30" id="tahir030" title="Link target outside of Sample">NINE</span></p>
<p class="toc1"><span href="#/Text/ch10#tahir31" id="tahir031" title="Link target outside of Sample">TEN</span></p>
<p class="toc1"><span href="#/Text/ch11#tahir32" id="tahir032" title="Link target outside of Sample">ELEVEN</span></p>
<p class="toc1"><span href="#/Text/ch12#tahir33" id="tahir033" title="Link target outside of Sample">TWELVE</span></p>
<p class="toc1"><span href="#/Text/ch13#tahir34" id="tahir034" title="Link target outside of Sample">THIRTEEN</span></p>
<p class="toc1"><span href="#/Text/ch14#tahir35" id="tahir035" title="Link target outside of Sample">FOURTEEN</span></p>
<p class="toc1"><span href="#/Text/ch15#tahir36" id="tahir036" title="Link target outside of Sample">FIFTEEN</span></p>
<p class="toc1"><span href="#/Text/ch16#tahir37" id="tahir037" title="Link target outside of Sample">SIXTEEN</span></p>
<p class="toc1"><span href="#/Text/ch17#tahir38" id="tahir038" title="Link target outside of Sample">SEVENTEEN</span></p>
<p class="toc1"><span href="#/Text/ch18#tahir39" id="tahir039" title="Link target outside of Sample">EIGHTEEN</span></p>
<p class="toc1"><span href="#/Text/ch19#tahir40" id="tahir040" title="Link target outside of Sample">NINETEEN</span></p>
<p class="toc1"><span href="#/Text/ch20#tahir41" id="tahir041" title="Link target outside of Sample">TWENTY</span></p>
<p class="toc1" style="margin-top:20px;"><span href="#/Text/teaser00" title="Link target outside of Sample">Preview: <i>Falsely Accused</i></span></p>
<p class="toc1"><span href="#/Text/bio" id="bio" title="Link target outside of Sample">A BIOGRAPHY OF ROBERT K. TANENBAUM</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?df68665c